import withLoader from 'components/organisms/withLoader';
import { useTranslation } from 'react-i18next';
import { useNewPatientsSendReport } from 'infrastructure/hooks/rpm/newPatientsReport/use-send-report';
import { useNewPatientsQueryFilter } from 'infrastructure/hooks/rpm/newPatientsReport/use-query-filter';
import NavigationHeader from 'components/molecules/navigation-header';
import ExpandableNewPatientsReportsFilters from 'components/molecules/new-patients-report/expandable-filters';
import NewPatientsTable from 'components/molecules/new-patients-report/table';
import BaseDownloadButton from 'components/atoms/download-button';
import BaseContainer from 'components/atoms/base-container';

import s from './styles.module.scss';

const NewPatients = () => {
  const { t } = useTranslation();
  const { filter, count, resetFilter, updateFilter } =
    useNewPatientsQueryFilter();
  const { isLoading, sendReportToEmail } = useNewPatientsSendReport(filter);

  return (
    <BaseContainer>
      <NavigationHeader title={t('labels.reportNewPatients')}>
        {withLoader(
          isLoading,
          <BaseDownloadButton
            onClick={sendReportToEmail}
            disabled={isLoading}
          />,
        )}
      </NavigationHeader>
      <div className={s.page}>
        <ExpandableNewPatientsReportsFilters
          count={count}
          data={filter}
          updateFilter={updateFilter}
          resetFilter={resetFilter}
        />
        <NewPatientsTable filters={filter} updateFilter={updateFilter} />
      </div>
    </BaseContainer>
  );
};

export default NewPatients;
